import * as React from "react";
import FormStepper from "../../../components/FormStepper/FormStepper";
import {InputTypes} from "../../../components/FormStepper/InputTypes";
import FormButton from "../../../../../components/FormButton/FormButton";

import {observer} from "mobx-react";
import {IManuallyBankAccountDetails} from "../../../../../../../shared/src/functions/membersApi/types/ISignupProcess";
import {StyleRulesCallback, WithStyles, withStyles} from "@material-ui/core/styles";
import Loader from "../../../../../components/Loader/Loader";

interface IProps {
    store: any;
    onBankSelected: (data: IManuallyBankAccountDetails) => void;
    backClick: () => void;
    isSending: boolean;
}

interface ILocalState {
    isFormFinish: boolean;
}

const storePropertyName = 'bankAccountDetails';

const FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS = {
    titles: {
        HEADER: "Bank Details",
        BANK_NAME: "Bank name",
        ACH_NUMBER: "Routing number",
        ACCOUNT_NUMBER: "Account number",
        ACCOUNT_NAME: "Account owner name",
        CELL_PHONE_NUMBER: "Cell Phone number",
        SUB_TITLE : "Insert account details to receive funds and submit payments"
    },
    placeHolders: {
        GENERAL: "Write here...",
    },
    propertyNames: {
        BANK_NAME: "bankName",
        ACH_NUMBER: "routingNumber",
        ACCOUNT_NUMBER: "accountNumber",
        ACCOUNT_NAME: "accountOwnerName",
        CELL_PHONE_NUMBER: "cellPhoneNumber",
    },
    errors: {
        INVALID_ACH_ROUTING: "Invalid routing number"
    }
};


const styles: StyleRulesCallback = ({ palette, spacing }) => ({
    back: {
        display: "flex",
        margin: "auto 0",
        fontSize: 14,
        fontWeight: 500,
        color: "#9ca6ad",
        cursor: "pointer"
    },
    info: {
        width: "90%",
        marginLeft: "auto",
        fontSize: 14,
        fontWeight: 500,
        color: "#9ca6ad",
    }

});

@observer
@(withStyles(styles) as any)
export default class FormBankSelectionManually  extends React.Component<
    IProps & Partial<WithStyles<any>>
    > {

    public state: ILocalState = {
        isFormFinish: false
    };

    constructor(props: IProps){
        super(props);
        if (!props.store.formInput[storePropertyName]) {
            props.store.formInput[storePropertyName] = {};
        }
    }

    public renderNextButton = () => {
        const classes = this.state.isFormFinish? "blue" : "disabled";
        return <FormButton click={this.navigateForward} btnText={'Next'} classes={classes}/>
    };

    public navigateForward = () => {
        const {store, onBankSelected} = this.props;
        if(this.state.isFormFinish) {
            onBankSelected(store.formInput.bankAccountDetails);
        }
    };

    public renderFormStepper = () => {
        const {store} = this.props;
        return <FormStepper steps={this.getManuallyBankDetailsSteps()} updateParentFormStatus={this.getFormStatus} store={store} navigationProperty={storePropertyName}/>
    };

    public renderPageNavigation = () =>  {
        return (
            <div className= {"form-navigation"}>
                {/*PLAID IDENTITY REQUIRED*/}
                {/*<div className={classes!.back} onClick={backClick}>Back</div>*/}
                <div className="link-next align-right">{this.renderNextButton()}</div>
            </div>
        )
    };

    public render() {
        const {isSending} = this.props;
        {return isSending? <Loader/> :
            <>
                {this.renderFormStepper()}
                {this.renderPageNavigation()}
            </>;
        }
    };

    private getManuallyBankDetailsSteps = () => {
        const ManuallyEnterBankSteps: any = [
            {
                isHeader: true,
                title: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.titles.HEADER,
                subTitle: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.titles.SUB_TITLE,
                inputType: InputTypes.none
            },

            // PLAID IDENTITY REQUIRED
            // {
            //     title: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.titles.ACH_NUMBER,
            //     inputPlaceHolder: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.placeHolders.GENERAL,
            //     inputType: InputTypes.number,
            //     propName: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.propertyNames.ACH_NUMBER,
            //     customValidationCheck: FormUtils.validate9CharactersLength,
            //     maxChars: 9,
            //     errorLabel: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.errors.INVALID_ACH_ROUTING,
            // },
            {
                title: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.titles.ACCOUNT_NUMBER,
                inputPlaceHolder: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.placeHolders.GENERAL,
                inputType: InputTypes.number,
                propName: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.propertyNames.ACCOUNT_NUMBER
            },
            {
                title: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.titles.ACCOUNT_NAME,
                inputPlaceHolder: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.placeHolders.GENERAL,
                inputType: InputTypes.text,
                propName: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.propertyNames.ACCOUNT_NAME
            },

             // PLAID IDENTITY REQUIRED
            // {
            //     title: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.titles.BANK_NAME,
            //     inputPlaceHolder: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.placeHolders.GENERAL,
            //     inputType: InputTypes.text,
            //     propName: FORM_MANUALLY_BANK_DETAILS_PAGE_TEXTS.propertyNames.BANK_NAME
            // },

        ];
        return ManuallyEnterBankSteps;
    };

    private getFormStatus = (isFormFinished: boolean) => {
        if(this.state.isFormFinish !== isFormFinished) {
            const newState = this.state;
            newState.isFormFinish = isFormFinished;
            this.setState(newState)
        }
    }
}




// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormBankSelection/FormBankSelectionManually.tsx